import { fade, Chip, makeStyles, useTheme } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

export const BADGES_COLOR_TYPES = {
  green: 'green',
  green2: 'green2',
  blue: 'blue',
  grey: 'grey',
  lightGrey: 'lightGrey',
  lightGrey2: 'lightGrey2',
  red: 'red',
  orange: 'orange',
  lightBlue: 'lightBlue',
  purple: 'purple',
  pink: 'pink',
};

export const COLOR_BY_TYPES = {
  green: 'badge_green',
  green2: 'badge_dark_green',
  lightBlue: 'badge_light_blue',
  lightGrey: 'badge_light_grey',
  lightGrey2: 'badge_light_grey',
  purple: 'badge_purple',
  blue: 'blue',
  grey: 'grey',
  red: 'darkError',
  orange: 'badge_orange',
  pink: 'badge_pink',
};

const useStyles = makeStyles((theme) => ({
  badge: {
    height: 24,
    borderRadius: theme.shape.borderRadius,
    border: 'none',
    fontSize: 13,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    padding: `0 ${theme.spacing(2)}px`,
    cursor: 'inherit',
  },
  badgeLabel: {
    padding: 0,
  },
  noHorizontalPaddings: {
    padding: 0,
  },
  green: {
    color: theme.colors.badge_green,
    borderColor: theme.colors.badge_green,
    backgroundColor: fade(theme.colors.badge_green, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_green, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_green,
      backgroundColor: fade(theme.colors.badge_green, 0.25),
    },
  },
  green2: {
    color: theme.colors.badge_dark_green,
    borderColor: theme.colors.badge_dark_green,
    backgroundColor: fade(theme.colors.badge_dark_green, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_dark_green, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_dark_green,
      backgroundColor: fade(theme.colors.badge_dark_green, 0.25),
    },
  },
  lightBlue: {
    color: theme.colors.badge_light_blue,
    borderColor: theme.colors.badge_light_blue,
    backgroundColor: fade(theme.colors.badge_light_blue, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_light_blue, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_light_blue,
      backgroundColor: fade(theme.colors.badge_light_blue, 0.25),
    },
  },
  lightGrey: {
    color: theme.colors.badge_light_grey,
    borderColor: theme.colors.badge_light_grey,
    backgroundColor: fade(theme.colors.badge_light_grey, 0.1),
    border: `0.5px solid ${theme.colors.badge_light_grey}`,

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_light_grey, 0.25),
    },
    '&:focus': {
      color: theme.colors.badge_light_grey,
      backgroundColor: fade(theme.colors.badge_light_grey, 0.1),
      border: `0.5px solid ${theme.colors.badge_light_grey}`,
    },
  },
  lightGrey2: {
    color: theme.colors.badge_light_grey,
    borderColor: theme.colors.badge_light_grey,
    backgroundColor: fade(theme.colors.badge_light_grey, 0.1),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_light_grey, 0.25),
    },
    '&:focus': {
      color: theme.colors.badge_light_grey,
      backgroundColor: fade(theme.colors.badge_light_grey, 0.1),
    },
  },
  purple: {
    color: theme.colors.badge_purple,
    borderColor: theme.colors.badge_purple,
    backgroundColor: fade(theme.colors.badge_purple, 0.25),
    border: `0.5px solid ${theme.colors.badge_purple}`,

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_purple, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_purple,
      backgroundColor: fade(theme.colors.badge_purple, 0.25),
      border: `0.5px solid ${theme.colors.badge_purple}`,
    },
  },
  blue: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
    backgroundColor: fade(theme.colors.blue, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.blue, 0.35),
    },
    '&:focus': {
      color: theme.colors.blue,
      backgroundColor: fade(theme.colors.blue, 0.25),
    },
  },
  grey: {
    color: fade(theme.colors.grey, 0.7),
    borderColor: fade(theme.colors.grey, 0.7),
    backgroundColor: fade(theme.colors.grey, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.grey, 0.35),
    },
    '&:focus': {
      color: theme.colors.grey,
      backgroundColor: fade(theme.colors.grey, 0.25),
    },
  },
  red: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    backgroundColor: fade(theme.palette.error.main, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.35),
    },
    '&:focus': {
      color: theme.palette.error.main,
      backgroundColor: fade(theme.palette.error.main, 0.25),
    },
  },
  orange: {
    color: theme.colors.badge_orange,
    borderColor: theme.colors.badge_orange,
    backgroundColor: fade(theme.colors.badge_orange, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_orange, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_orange,
      backgroundColor: fade(theme.colors.badge_orange, 0.25),
    },
  },
  pink: {
    color: theme.colors.badge_pink,
    borderColor: theme.colors.badge_pink,
    backgroundColor: fade(theme.colors.badge_pink, 0.25),

    '&:hover': {
      backgroundColor: fade(theme.colors.badge_pink, 0.35),
    },
    '&:focus': {
      color: theme.colors.badge_pink,
      backgroundColor: fade(theme.colors.badge_pink, 0.25),
    },
  },
  badgeFixedWidth: {
    width: 120,
    padding: `0 ${theme.spacing(1)}px`,
  },
  diagonalBorderRadius: {
    borderRadius: '0 8px',
  },
  bottomLeftRadius: {
    borderRadius: '0 0 0 8px',
  },
  whiteBg: {
    backgroundColor: 'white',
    border: '1px solid',
  },
  removeHover: {
    '&:hover': {
      backgroundColor: 'initial !important',
    },
    '&:focus': {
      color: 'initial !important',
      backgroundColor: 'initial !important',
    },
  },
}));

export const Badge = ({
                        fixedWidth,
                        label,
                        colorType,
                        diagonalBorderRadius,
                        bottomLeftRadius,
                        customStyle,
                        variant,
                        onClick,
                        ...restProps
                      }) => {
  const classes = useStyles();
  const theme = useTheme();
  const color = COLOR_BY_TYPES[colorType] || 'badge_light_grey';
  return (
    <Chip
      className={cx(
        classes.badge,
        customStyle, {
          [classes.badgeFixedWidth]: fixedWidth,
          [classes.diagonalBorderRadius]: diagonalBorderRadius,
          [classes.bottomLeftRadius]: bottomLeftRadius,
        },
      )}
      classes={{ label: classes.badgeLabel }}
      style={{
        color: theme.colors[color],
        border: `1px solid ${variant === 'outlined' ? fade(theme.colors[color], 0.4) : 'transparent'}`,
        backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], 0.25),

        '&:hover': {
          backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], onClick ? 0.35 : 0.25),
        },
        '&:focus': {
          color: theme.colors[color],
          backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], 0.25),
        },
      }}
      label={label}
      onClick={onClick}
      variant={variant}
      {...restProps}
    />
  );
};


export const SimpleBadge = ({
                              label,
                              colorType,
                              variant,
                            }) => {
  const theme = useTheme();
  const color = COLOR_BY_TYPES[colorType] || 'badge_light_grey';
  return (
    <div style={{
      height: 24,
      borderRadius: theme.shape.borderRadius,
      letterSpacing: 1,
      cursor: 'inherit',
      minWidth: 'max-content',
      maxWidth: 'fit-content',
      fontSize: 10,
      fontWeight: 500,
      padding: '0px 8px',
      display: 'flex',
      alignItems: 'center',
      textTransform: 'none',
      color: theme.colors[color],
      border: `1px solid ${variant === 'outlined' ? fade(theme.colors[color], 0.4) : 'transparent'}`,
      backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], 0.25),

      '&:hover': {
        backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], 0.25),
      },
      '&:focus': {
        color: theme.colors[color],
        backgroundColor: variant === 'outlined' ? 'white' : fade(theme.colors[color], 0.25),
      },
    }}
    >{label}</div>
  );
};

Badge.propTypes = {
  label: PropTypes.string,
  colorType: PropTypes.string,
  fixedWidth: PropTypes.bool,
  diagonalBorderRadius: PropTypes.bool,
  bottomLeftRadius: PropTypes.bool,
  customStyle: PropTypes.string,
};

Badge.defaultProps = {
  label: undefined,
  colorType: undefined,
  fixedWidth: false,
  diagonalBorderRadius: false,
  bottomLeftRadius: false,
  customStyle: undefined,
};
